import api, { APIURL, authenHeader, errorHandle } from "../api/api"
import { dateTH } from '../utils/dateUtils'

class Contract {
    constructor(obj){
        //console.log(obj)
        this.id = obj.ID
        this.tenant_uid = obj.tenant_uid
        this.first_name = obj.first_name
        this.last_name = obj.last_name
        this.position_name = obj.position_name
        this.office_name = obj.office_name
        this.level_id = obj.level_id
        this.contract_date = obj.contract_date
        this.contract_no = obj.contract_no
        this.room_no = obj.room_no
        this.residence_id = obj.residence_id
        this.residence_name = obj.Residence?.name
        this.contract_age = obj.contract_age
        this.contract_start_date =obj.contract_start_date
        this.contract_end_date = obj.contract_end_date
        this.status = obj.status
    }

    export(index) {
        return {
            "ลำดับ": index+1,
            "ชื่อ": this.first_name,
            "นามสกุล": this.last_name,
            "ตำแหน่ง": this.position_name,
            "สังกัด": this.office_name,
            "วันที่ทำสัญญา": dateTH(this.contract_date),
            "เลขที่สัญญา": this.contract_no,
        }
    }
}

export default Contract

export const getAllContracts = (query, token) => {
    const headers = {
        headers: authenHeader(token)
    }
    return new Promise((resolve, reject) => {
        api.get(APIURL.CONTRACT(query), headers)
            .then(res => {
                if (res.data.data) {
                    const list = res.data.data?.map(i => new Contract(i))
                    resolve(list)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}

export const getOwnerActiveContract = (token) => {
    const headers = {
        headers: authenHeader(token)
    }
    const query = "me?status=ACTIVE"
    return new Promise((resolve, reject) => {
        api.get(APIURL.CONTRACT(query), headers)
            .then(res => {
                if (res.data.data) {
                    const list = res.data.data?.map(i => new Contract(i))
                    resolve(list)
                } else {
                    resolve(res.data)
                }
            })
            .catch(error => {
                reject(errorHandle(error))
            })
    })
}